import { Action, createReducer, on } from '@ngrx/store';
import { MessageFilterActions } from './message-filter.actions';

export const STORE_FEATURE_KEY_MESSAGE_FILTER = 'messageFilter';

export class MessageFilterState {
    loading: boolean;
    destinatorFilters: Array<any>;
    saving: boolean;
    saved: boolean;
}

export const initializeMessageFilterState: MessageFilterState = {
    loading: false,
    destinatorFilters: undefined,
    saving: false,
    saved: false
};

const reducer = createReducer(
    initializeMessageFilterState,
    on(MessageFilterActions.getDestinatorFiltersByPersonId, (state, payload) =>
        ({
            ...state,
            loading: true,
            destinatorFilters: undefined, // Clear any previous (which could be for other destinator)
            saving: false,
            saved: false
        })),
    on(MessageFilterActions.getDestinatorFiltersByPersonIdSuccess, (state, {destinatorFilters}) =>
        ({
            ...state,
            loading: false,
            destinatorFilters
        })),
    on(MessageFilterActions.getDestinatorFiltersByPersonIdFail, (state, payload) =>
        ({
            ...state,
            loading: false
        })),

    on(MessageFilterActions.updateDestinatorFilters, (state, payload) =>
        ({
            ...state,
            saving: true,
            saved: false
        })),
    on(MessageFilterActions.updateDestinatorFiltersSuccess, (state, payload) =>
        ({
            ...state,
            saving: false,
            saved: true
        })),
    on(MessageFilterActions.updateDestinatorFiltersFail, (state, payload) =>
        ({
            ...state,
            saving: false,
            saved: false
        }))
);

// tslint:disable-next-line:typedef only-arrow-functions
export function MessageFilterReducer(state: MessageFilterState | undefined, action: Action) {
    return reducer(state, action);
}
